import { ParsedChartProps } from 'types'
import GoogleChart from '../GoogleChart'
import {
  defaultChartProps,
  makeChartData,
  makeDefaultChartOptions,
  transposeData,
} from '../chartUtils'

export default function BarChart({ isStacked, onSelect, ...props }: ParsedChartProps) {
  const defaultProps = makeDefaultChartOptions(props)
  const options = {
    ...defaultProps,
    isStacked,
    hAxis: {
      ...defaultProps?.hAxis,
      viewWindowMode: isStacked ? 'maximized' : 'pretty',
    },
  }

  const data = makeChartData(props)

  return (
    <GoogleChart
      {...defaultChartProps}
      chartType="BarChart"
      data={isStacked ? transposeData(data) : data}
      options={options}
      onSelect={onSelect}
    />
  )
}
